import { useQuery } from '@tanstack/react-query';

import { getPromoActivitySummary, parsePromoActivitySummary } from '~/services/PromoService';

export const promoActivitySummaryQueryKeys = {
  all: ['promo-activity-summary'] as const,
  current: () => [...promoActivitySummaryQueryKeys.all, 'current'] as const,
};

/** The activity window is loaded deliberately from Promo Tools, rather than on page entry. */
export function useGetPromoActivitySummary({ enabled = false }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: promoActivitySummaryQueryKeys.current(),
    queryFn: async ({ signal }) => {
      const response = await getPromoActivitySummary({ signal });
      if (response.status !== 200) {
        throw new Error(response.message ?? 'Unable to load recent promo activity.');
      }
      return parsePromoActivitySummary(response.result);
    },
    enabled,
  });
}
